exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".DatenSchutzPage section{margin-bottom:40px;text-align:center}.DatenSchutzPage section h3{margin-bottom:20px}.DatenSchutzPage section .list-container{display:flex;font-size:15pt;font-weight:300;margin-bottom:15px}.DatenSchutzPage section ul{display:block;margin:0 auto}.DatenSchutzPage section ul li{text-align:left}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/Containers/Pages/DatenSchutzPage.scss
// module id = 1073
// module chunks = 0